export default __webpack_public_path__ + "static/media/TD_SYNNEX_logo.0b7e9756.png";